import { render, staticRenderFns } from "./PackagesRelated.vue?vue&type=template&id=0a18afbd"
import script from "./PackagesRelated.vue?vue&type=script&lang=js"
export * from "./PackagesRelated.vue?vue&type=script&lang=js"
import style0 from "./PackagesRelated.vue?vue&type=style&index=0&id=0a18afbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports